import { transformMethodsByRegions } from '@/common/helpers/helpers'

import { mergeConfig, strategies } from './constants'

const mergeLogisticsMethodsInfo = logisticsMethods => {
  return logisticsMethods?.reduce((acc, method) => {
    Object.entries(method).forEach(([key, value]) => {
      const strategy = mergeConfig[key]
      if (strategy) {
        strategy(acc, key, value)
      }

      if (typeof value === 'boolean') {
        strategies.booleanOr(acc, key, value)
      }

      strategies.keepFirst(acc, key, value)
    })

    return acc
  }, {})
}

const buildDeliveryMethod = (deliveryMethod, logisticsDeliveryMethods) => {
  const logisticsMethodsFiltered = deliveryMethod?.delivery_method_ids
    ?.map(id => logisticsDeliveryMethods?.find(ldm => ldm.id === id))
    ?.filter(Boolean)

  const mergedInfo = mergeLogisticsMethodsInfo(logisticsMethodsFiltered)
  return {
    ...deliveryMethod,
    ...mergedInfo,
  }
}

export const getDeliveryMethods = (deliveryMethods, logisticsDeliveryMethods, regions) => {
  if (!deliveryMethods?.length && !logisticsDeliveryMethods?.length) return []

  const deliveryMethodsMerged = deliveryMethods?.map(dm => buildDeliveryMethod(dm, logisticsDeliveryMethods))

  return transformMethodsByRegions(deliveryMethodsMerged, regions)
}
